import { Dialog } from "@mui/material";
import { Button } from "../../common/Button/Button";
import { useEffect, useMemo, useState } from "react";
import { AgGridReact } from "ag-grid-react";

import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { ButtonHolder, ButtonPrimary } from "./style";

const defaultColDef = {
  resizable: true,
  sortable: true,
  filter: true,
  flex: 1,
  minWidth: 150, // 👈 minimum width for all columns
};

export const AGGTable = ({ parsedData }: { parsedData: any }) => {
  const [rowData, setRowData] = useState<any>([]);
  const [columnDefs, setColumnDefs] = useState<any>([]);

  useEffect(() => {
    if (parsedData?.length > 0) {
      const columns = Object.keys(parsedData[0] || {}).map((key) => ({
        field: key,
        editable: true,
      }));

      setColumnDefs(columns);
      setRowData(parsedData);
    }
  }, [parsedData]);

  return (
    <>
      {rowData.length > 0 && (
        <div
          style={{
            width: "100%",
            overflowX: "auto",
          }}
        >
          <div
            className="ag-theme-alpine"
            style={{
              height: 500,
              width: "100%",
              minWidth: "800px",
            }}
          >
            <AgGridReact
              rowData={rowData}
              columnDefs={columnDefs}
              defaultColDef={defaultColDef}
              animateRows={true}
            />
          </div>
        </div>
      )}
    </>
  );
};
